import api, { apiV1 } from '~/services/api';

const generateToken = (isTest: boolean | string) =>
  apiV1.request({
    data: {
      created: null,
      test: isTest,
      token: null,
    },
    method: 'POST',
    url: '/authentication_tokens/v2/',
  });

const getToken = () =>
  apiV1.request({
    url: '/authentication_tokens/v2/',
  });

const deleteToken = (objectId: string) =>
  apiV1.request({
    method: 'DELETE',
    url: `/authentication_tokens/v2/${objectId}`,
  });

const getApiKeyGenerationEligibility = async () => {
  const response = await api.request<{ is_blocked: boolean }>({
    method: 'GET',
    params: { feature: 'IS_API_KEY_GENERATION_BLOCKED' },
    url: 'v1/fraud-decisions/eligibility',
  });
  return response.data;
};

export { deleteToken, generateToken, getApiKeyGenerationEligibility, getToken };
